import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  namespaced: true,
  state: {
    operators: [],
    allOperators: [],
  },
  mutations: {
    setOperators(state, payload) {
      state.operators = payload;
    },
    setAllOperators(state, payload) {
      state.allOperators = payload;
    },
  },
  actions: {
    async getOperators({ commit, rootState: { locations } }, {
      suffix = locations.suffix, pageNum = 1, pageSize = 10,
    }) {
      try {
        const { data } = await HTTP.get(`${suffix}/operator`, {
          params: {
            suffix, pageNum, pageSize,
          },
        });
        commit('setOperators', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async getAllOperators(
      { commit, rootState: { locations } },
      { suffix = locations.suffix } = {},
    ) {
      try {
        const { data } = await HTTP.get(`${suffix}/operator/list`, {
          params: { suffix },
        });
        commit('setAllOperators', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async syncOperator({ rootState: { locations } }, { suffix = locations.suffix, email }) {
      try {
        await HTTP.post(`${suffix}/operator/sync`, { email });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },
  },
  getters: {
    operatorById: ({ allOperators }) => allOperators.reduce((acc, { id, name }) => {
      acc[id] = name;
      return acc;
    }, {}),
  },
};
